const Status = {
    InWarehouse: 1,
    AtClient: 2
}

export default { Status }